module.exports = __webpack_public_path__ + "img/blefo.58edba69.jpg";